import { createSlice } from '@reduxjs/toolkit';

type IDataSchema = {
  tag: string
  type: string
  label: string
  value: string
  invalid: boolean,
  placeholder: string
};

type IData = {
  id: string
  created_at: string
  created_by: string
  document_id: string
  is_active: boolean,
  schema: IDataSchema[]
}

type RequestCommandState = {
  loading: boolean;
  data: IData | null;
};


const initialState: RequestCommandState = {
  loading: false,
  data: null,
};

export const dynamicFormFields = createSlice({
  name: 'dynamicFormFields',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export default dynamicFormFields.reducer;
